import {
  englishLocalisation,
  finnishLocalisation,
  norwegianLocalisation,
  danishLocalisation,
} from './translations';
export type { TextLocalisation } from './translations';

export enum Locale {
  EN = 'en-GB',
  NO = 'no-NO',
  FI = 'fi-FI',
  DA = 'da-DK',
}

export enum Brand {
  MobilePay = 'MobilePay',
  Vipps = 'Vipps',
}

export const CurrentTheme: Brand =
  new URLSearchParams(window.location.search).get('brand') === 'mp' ? Brand.MobilePay : Brand.Vipps;

const normalizedLocale = {
  en: Locale.EN,
  no: Locale.NO,
  nb: Locale.NO,
  nn: Locale.NO,
  fi: Locale.FI,
  da: Locale.DA,
} as const;

function getLocaleQuery(): string | undefined {
  const params = new URLSearchParams(window.location.search);
  const localeParam = params.get('locale');
  return localeParam ? localeParam : undefined;
}

const DEFAULT_LOCALE = Locale.EN;

const browserLocale = (
  getLocaleQuery() ??
  navigator.languages?.[0] ??
  navigator.language ??
  DEFAULT_LOCALE
)
  .toLowerCase()
  .split(/[-_]/)[0] as keyof typeof normalizedLocale;

export const CurrentLocale: Locale = normalizedLocale[browserLocale] ?? DEFAULT_LOCALE;

export const translationsMap = {
  [Locale.EN]: englishLocalisation,
  [Locale.NO]: norwegianLocalisation,
  [Locale.FI]: finnishLocalisation,
  [Locale.DA]: danishLocalisation,
} as const;

export const currentTranslations = translationsMap[CurrentLocale];
